const MAX_ERROR_EXCERPT_LENGTH = 200;

async function extractErrorMessage(response, fallbackMessage) {
  let errorMessage = `${fallbackMessage} (Status: ${response.status})`;

  try {
    const errorData = await response.clone().json();
    if (errorData?.error) {
      return errorData.error;
    }
    if (errorData?.message) {
      return errorData.message;
    }
  } catch (jsonError) {}

  try {
    const errorText = await response.text();
    const excerpt = errorText.substring(0, MAX_ERROR_EXCERPT_LENGTH);
    if (excerpt) {
      return `${errorMessage}: ${excerpt}`;
    }
  } catch (textError) {}

  return errorMessage;
}

export async function getJsonOrError(
  response,
  errorMessage = 'Error when fetching data',
) {
  if (response.status >= 200 && response.status < 300) {
    return await response.json();
  }

  throw new Error(await extractErrorMessage(response, errorMessage));
}

export async function getBlobOrError(
  response,
  errorMessage = 'Error when fetching data',
) {
  if (response.status >= 200 && response.status < 300) {
    return await response.blob();
  }

  throw new Error(await extractErrorMessage(response, errorMessage));
}
